module.exports = __webpack_public_path__ + "static/1-95b17a0fd249140dfe1abec4572f4fe4.jpg";